import React,{ useEffect,useMemo,useState } from "react";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Spinner, } from "reactstrap";
import { bulkAssignLeadApi, getReassignUserListApi } from "../../apiServices/leadAssignment.services";
import { toast } from "react-toastify";

function LeadAssignModal({ isOpen, toggle, leads = [],onSuccess=()=>{}, }){
    const [users,setUsers]=useState([]);
    const [selectedUser,setSelectedUser]=useState(null);
    const [loading,setLoading]=useState(false);
    const loadUsers=async()=>{
        try{
            const response= await getReassignUserListApi();
            setUsers( response?.data || [] );
        }catch(error){
            toast.error( error?.message || "Failed to load users" );
        }
    };
  useEffect(()=>{ if(!isOpen){ return; } loadUsers(); },[isOpen]);
  
  const buildOptions = (user, level = 0) => {
    const prefix = "— ".repeat(level);

    let arr = [
      {
        value: user._id,
        label:
          level === 0
            ? `👤 ${user.firstName} ${user.lastName} (Manager)`
            : `${prefix}${user.firstName} ${user.lastName}`,
      },
    ];

    if (user.reportees?.length) {
      user.reportees.forEach((child) => {
        arr.push(...buildOptions(child, level + 1));
      });
    }

    return arr;
  };
  const userOptions = useMemo(() => {
    return users.map((manager) => ({
      label: `${manager.firstName} ${manager.lastName}`,
      options: buildOptions(manager),
    }));
  }, [users]);

  const handleAssign=async()=>{

    if(!selectedUser){
      return toast.error("Please select a user");
    }

    try{

      setLoading(true);

      await bulkAssignLeadApi({
        leads,
        assignedTo: selectedUser.value,
      });

      toast.success(
        `${leads.length} leads assigned successfully`
      );

      setSelectedUser(null);

      toggle();

      onSuccess();

    }catch(error){

      toast.error(
        error?.message ||
        error?.error ||
        "Failed to assign leads"
      );

    }finally{
      setLoading(false);
    }
  };

  return(
    <Modal isOpen={isOpen} toggle={toggle} centered size="md" >
      <ModalHeader toggle={toggle}> Assign {leads.length} Lead(s) </ModalHeader>

      <ModalBody>

        <div className="mb-3">
          <Label className="fw-semibold">
            Assign To
          </Label>

          <Select
            options={userOptions}
            value={selectedUser}
            onChange={setSelectedUser}
            placeholder="Search user..."
            isClearable
            menuPortalTarget={document.body}
            styles={{
                menuPortal:base=>({
                ...base,
                zIndex:9999,
                }),
            }}
            />
        </div>

        <div className="alert alert-info mb-0">
          <strong>{leads.length}</strong> lead(s) selected
        </div>

      </ModalBody>

      <ModalFooter>

        <Button
          color="light"
          onClick={toggle}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={handleAssign}
          disabled={!selectedUser || loading}
        >
          {
            loading
              ? <><Spinner size="sm" /> Assigning...</>
              : "Assign"
          }
        </Button>

      </ModalFooter>
    </Modal>
  );
}

export default LeadAssignModal;